export enum FileSize {
  Max1Mb = 1 * 1000 * 1024,
  Max5Mb = 5 * 1000 * 1024,
  Max10Mb = 10 * 1000 * 1024,
  Max100Mb = 100 * 1000 * 1024,
  Max1000Mb = 1000 * 1000 * 1024,
}
